module.exports = __webpack_public_path__ + "img/WHEN-logo.835de59b.png";